import { render, staticRenderFns } from "./InsuranceSelect.vue?vue&type=template&id=cf8ff532"
import script from "./InsuranceSelect.vue?vue&type=script&lang=js"
export * from "./InsuranceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports